// extracted by mini-css-extract-plugin
module.exports = {"main":"ThPackHeading_main__w6a7Z","thWrapper":"ThPackHeading_thWrapper__9Oz6s","title":"ThPackHeading_title__OQUuy","thBadge":"ThPackHeading_thBadge__K1LNb"};